export const Marquee = ({ text, className = "" }) => {
  const segment = `${text} — `;
  return (
    <div className={`overflow-hidden whitespace-nowrap border-y border-white/10 py-5 ${className}`} data-testid="editorial-marquee">
      <div className="animate-marquee inline-block">
        <span className="text-lg sm:text-xl font-heading font-semibold tracking-tight">{segment}</span>
        <span className="text-lg sm:text-xl font-heading font-semibold tracking-tight">{segment}</span>
      </div>
      <div className="animate-marquee inline-block" aria-hidden="true">
        <span className="text-lg sm:text-xl font-heading font-semibold tracking-tight">{segment}</span>
        <span className="text-lg sm:text-xl font-heading font-semibold tracking-tight">{segment}</span>
      </div>
    </div>
  );
};
